import { useState } from "react";
import { useEffect } from "react";
import ReactSelect from 'react-select';
import Fetch from '../../../functions/Fetch';

function SelectIcons(props) {

  let [value, updateValue] = useState(props.value);
  let [options, updateOptions] = useState(props.options);
  let [error, updateError] = useState(props.error);
  let className = '';
  let customStyle = {};

  useEffect(() => {
    const loadOptions = async () => {
      let option = options.filter(selected => selected.value == value.value);
      updateValue(option);
      if(props.optionsEndpoint && props.optionsEndpoint.endpoint){
        let url  = props.optionsEndpoint.endpoint;
        let keyLabel = props.optionsEndpoint.label;
        let keyValue = props.optionsEndpoint.value;
        const params = props.optionsEndpoint.params?props.optionsEndpoint.params:{};
        let rows = await Fetch.post(url,params);
        const tempOptions = rows.map(item => (
          {
            value: item[keyValue],
            label: item[keyLabel]
          }
        ));
        option = tempOptions.filter(selected => selected.value == value.value);
        updateOptions(tempOptions);
        updateValue(option);
      }
    }
    loadOptions();
  }, []);

  const handleChange = element => {
    const target = {
      name:props.name,
      type: 'select',
      ...element
    }
    updateValue(element);
    props.onChange({target:target});
  };

  if (props.error) {
    className = "is-invalid";
    customStyle = {border:'1px solid #dc3545'};
  }

  const CustomOption = ({ label, icon }) => (
    <div>
      <span className={`mx-2 ${icon}`} />
      {label}
    </div>
  );

  return (
    <div>
      <div style={customStyle}>
      <ReactSelect
        autoFocus={props.autoFocus?true:false}
        isClearable={props.value !== null}
        name={props.name}
        placeholder={props.placeholder ? props.placeholder : 'Selecione'}
        options={options}
        getOptionLabel={({ label, value }) => (
          <CustomOption label={label} icon={value} />
        )}
        getOptionValue={(option) => option.value}
        onChange={handleChange}
        value={value}
        isDisabled={props.disabled}
      />
      </div>
      {props.error && (
          <span 
              class="error invalid-feedback" 
              style={{display:'inline'}}>
                  {props.error}
          </span>
      )}
    </div>
  );
}
export default SelectIcons;
